export default `Region,Population
Cherkasy Oblast,1206351
Chernihiv Oblast,1005745
Chernivtsi Oblast,904374
Dnipropetrovsk Oblast,3206477
Donetsk Oblast,4165901
Ivano-Frankivsk Oblast,1373252
Kharkiv Oblast,2675598
Kherson Oblast,1037640
Khmelnytskyi Oblast,1264705
Kiev Oblast,1767940
Kirovohrad Oblast,945549
Luhansk Oblast,2151833
Lviv Oblast,2522021
Mykolaiv Oblast,1131096
Odessa Oblast,2380308
Poltava Oblast,1400439
Rivne Oblast,1157301
Sumy Oblast,1081418
Ternopil Oblast,1045879
Vinnytsia Oblast,1560394
Volyn Oblast,1035330
Zakarpattia Oblast,1256802
Zaporizhia Oblast,1705836
Zhytomyr Oblast,1220193
Crimea,1967000
Kiev City,2887974
Sevastopol*,340735`